module.exports = __webpack_public_path__ + "img/blue_056.fc994f91.png";